<div class="config-section">
    <div class="loading-skeleton" *ngIf="loading">
        <app-skeleton-loader *ngFor="let i of [1, 2, 3, 4]" height="48px" borderRadius="8px"></app-skeleton-loader>
    </div>

    <ng-container *ngIf="!loading">
        <!-- Statuses are defined by the connected external system: read-only here -->
        <div class="statuses-locked-banner" *ngIf="locked">
            {{ 'permit.config.statuses.locked_banner' | translate }}
        </div>

        <!-- Default statuses block -->
        <div class="status-block">
            <h3 class="block-title">{{ 'permit.config.statuses.default_title' | translate }}</h3>

            <div class="status-card" *ngFor="let status of defaultStatuses">
                <div class="status-content">
                    <div class="status-info">
                        <div class="status-color" [style.backgroundColor]="status.color"></div>
                        <div class="status-title">{{ statusName(status) }}</div>
                        <div class="status-badge status-badge--default">
                            {{ 'permit.config.statuses.default_badge' | translate }}
                        </div>
                        <div class="status-badge status-badge--terminal" *ngIf="status.terminal">
                            {{ 'permit.config.statuses.terminal_badge' | translate }}
                        </div>
                    </div>
                    <!-- No kebab for default statuses (read-only) -->
                </div>
            </div>
        </div>

        <!-- Custom statuses block -->
        <div class="status-block">
            <h3 class="block-title">{{ 'permit.config.statuses.custom_title' | translate }}</h3>

            <div class="empty-state" *ngIf="!customStatuses.length">
                {{ 'permit.config.statuses.empty' | translate }}
            </div>

            <div class="status-card" *ngFor="let status of customStatuses">
                <div class="status-content">
                    <div class="status-info">
                        <div class="status-color" [style.backgroundColor]="status.color"></div>
                        <div class="status-title">{{ statusName(status) }}</div>
                        <div class="status-badge status-badge--terminal" *ngIf="status.terminal">
                            {{ 'permit.config.statuses.terminal_badge' | translate }}
                        </div>
                    </div>

                    <div class="status-actions" *ngIf="!locked">
                        <button mat-icon-button [matMenuTriggerFor]="menu" class="more-button">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #menu="matMenu">
                            <button mat-menu-item (click)="onEdit(status)">
                                <span>{{ 'permit.config.common.edit' | translate }}</span>
                            </button>
                            <button mat-menu-item (click)="confirmDelete(status)">
                                <span>{{ 'permit.config.common.delete' | translate }}</span>
                            </button>
                        </mat-menu>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
